import React from "react";
import PropTypes from "prop-types";
import BoxOfficeAccessVoucherForm from "./BoxOfficeAccessVoucherForm";
import { connect } from "react-redux";
import { selectEvent } from "../../../../redux/preferences/selectors";
import {
  ajaxErrorHandler,
  defaultError,
  defaultSuccess,
  getPrinterForDayPeriod
} from "../../../../libs/utils";
import {
  printWristband,
  redeemAccessVoucherByBarcode
} from "../../../../services/api/accessVouchers";
import { printZPL } from "../../../../services/printer";
import { printerSettings } from "../../../../redux/printers/selectors";
import { Base64 } from "js-base64";

class _BoxOfficeBarcode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
    printerSettings: PropTypes.object
  };

  _handleSubmit(values) {
    return new Promise((resolve, reject) => {
      redeemAccessVoucherByBarcode(this.props.event.id, values.barcode)
        .then(wristband => {
          const day = wristband.accessVoucher.accessVoucherTemplate.day
            ? wristband.accessVoucher.accessVoucherTemplate.day
            : "combi";
          const period = wristband.accessVoucher.accessVoucherTemplate.period;

          if (wristband.printedAt === null) {
            getPrinterForDayPeriod(day, period, this.props.printerSettings)
              .then(printer => {
                printWristband(wristband.id, {
                  printerName: printer.name
                })
                  .then(response => {
                    const zpl = Base64.decode(wristband.zpl);
                    printZPL(printer, zpl);
                    defaultSuccess("Wristband Printed");
                    resolve();
                  })
                  .catch(e => {
                    reject(e);
                    ajaxErrorHandler(e);
                  });
              })
              .catch(e => {
                reject(e);
                ajaxErrorHandler(e);
              });
          } else {
            // Confirm(
            //   `This Access Voucher has already been redeemed. Do you want to reprint? This will cause the previous wristband to become invalid`,
            //   {
            //     title: 'Access Voucher already redeemed',
            //     confirmStyle: 'btn-danger',
            //     confirmText: 'Reprint'
            //   }
            // ).then(
            //   result => {
            //     getPrinterForDayPeriod(day, period, this.props.printerSettings).then(printer => {
            //       reprintAccessVoucherWristband(wristband.crewMember.registrationId, wristband.accessVoucher.id)
            //         .then(response => {
            //           printWristband(response.id, {
            //             printerName: printer.name
            //           }).then(() => {
            //             const zpl = Base64.decode(response.zpl);
            //             printZPL(printer, zpl);
            //             defaultSuccess('Wristband Printed');
            //             resolve();
            //           });
            //         })
            //         .catch(ajaxErrorHandler);
            //     });
            //   },
            //   result => {
            //     resolve();
            //   }
            // );
            defaultError("Voucher already Printed");
          }
        })
        .catch(e => {
          reject(e);
          ajaxErrorHandler(e);
        });
    });
  }

  render() {
    return <BoxOfficeAccessVoucherForm onSubmit={this._handleSubmit} />;
  }
}
const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state),
    printerSettings: printerSettings(state)
  };
};

const BoxOfficeAccessVoucher = connect(
  mapStateToProps,
  mapDispatchToProps
)(_BoxOfficeBarcode);

export default BoxOfficeAccessVoucher;
